/*
 * Gallery
 * + Photoviewer
 * 
 * @author: Elton Jain
*/

define('modules/common/Gallery',[
    'jquery',
    'UI',
    'vendor/photoswipe/photoswipe.min',
    'vendor/photoswipe/photoswipe-ui.min'
], function ($, UI, PhotoSwipe, PhotoSwipeUI) {
    "use strict";
    
    return function (options) {
        var _self = this,
            defaults = {
                elePhotoPopup: '#pswp',
                eleGallery: '#gallery',
                eleGalleryData: '#galleryData',     // Json string stored in script/template
                photoDataJSON: {},
                history: false,
                //firstSlide: 0                            // First slide to show
            };
        
        // Options
        var o = $.extend(defaults, options);

        // Initialize
        _self.init = function (options) {
            var base = this;

            // Only do it when gallery found or called
            if($(o.eleGallery)) {
                o.photoDataJSON = $.parseJSON($(o.eleGalleryData).html());
                bindEvents();
            }

        };

        function bindEvents () {
            var base = this;

            // On click of thumbnail
            UI.$b.on('click', o.eleGallery + ' li', function (e) {
                e.preventDefault();
                var $ele = $(this),
                    idx = $ele.index(),
                    params = {
                        // optionName: 'option value'
                        // for example:
                        loop: false,
                        index: $ele.index(),
                        history: false
                    };

                // Initializes and opens PhotoSwipe
                var gallery = new PhotoSwipe( $(o.elePhotoPopup)[0], PhotoSwipeUI, o.photoDataJSON, params);
                History.pushState({
                    popupId: 'pswp',
                    removeEl: false
                });
                gallery.init();

                return false;
            });

        };

        _self.init(options);

        return _self;
    };

});
